import Header from "./Header";
import React, { useEffect, useState } from "react";
import fire from "./Firebase";

import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../Footer";
import { toast } from "react-toastify";

function Contact() {
  document.title='HR School - Contact Us'
  var [inputsdata, setinputsdata] = useState();

  function collect(e) {
    setinputsdata({ ...inputsdata, [e.target.name]: e.target.value });
  }
  function store() {
    fire.child("contactdata").push(inputsdata, (er) => {
      if (inputsdata == null) {
        toast.error("Fill All Deta");
      } else toast.success("Success");
      window.location.reload(false);
    });
  }

  return (
    <div>
      <Header />
      <div>
        <section
          id="page-banner"
          className="pt-105 pb-130 bg_cover"
          data-overlay={8}
          style={{ backgroundImage: "url(images/page-banner-6.jpg)" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-banner-cont">
                  <h2>Contact</h2>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Contact
                      </li>
                    </ol>
                  </nav>
                </div>{" "}
                {/* page banner cont */}
              </div>
            </div>{" "}
            {/* row */}
          </div>{" "}
          {/* container */}
        </section>

        <section id="contact-page" className="pt-90 pb-120 gray-bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="contact-from mt-30">
                  <div className="section-title">
                    <h5>Contact Us</h5>
                    <h2>Keep in touch</h2>
                  </div>
                  {/* section title */}
                  <div className="main-form pt-45">
                    <form
                      id="contact-form"
                      action="#"
                      method="post"
                      data-toggle="validator"
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="singel-form form-group">
                            <input
                              name="name"
                              onChange={collect}
                              type="text"
                              placeholder="Your name"
                              data-error="Name is required."
                              required="required"
                            />
                            <div className="help-block with-errors" />
                          </div>
                          {/* singel form */}
                        </div>
                        <div className="col-md-6">
                          <div className="singel-form form-group">
                            <input
                              name="email"
                              onChange={collect}
                              type="email"
                              placeholder="Email"
                              data-error="Valid email is required."
                              required="required"
                            />
                            <div className="help-block with-errors" />
                          </div>
                          {/* singel form */}
                          {/* </div>
                 <div className="col-md-6">
                  <div className="singel-form form-group">
                    <input
                      name="subject"
                      type="text"
                      placeholder="Subject"
                      data-error="Subject is required."
                      required="required"
                    />
                    <div className="help-block with-errors" />
                  </div>  */}
                          {/* singel form */}
                        </div>
                        <div className="col-md-12">
                          <div className="singel-form form-group">
                            <input
                              name="phone"
                              type="text"
                              onChange={collect}
                              placeholder="Phone"
                              data-error="Phone is required."
                              required="required"
                            />
                            <div className="help-block with-errors" />
                          </div>
                          {/* singel form */}
                        </div>
                        <div className="col-md-12">
                          <div className="singel-form form-group">
                            <textarea
                              name="complain"
                              placeholder="Messege"
                              onChange={collect}
                              data-error="Please,leave us a message."
                              required="required"
                              defaultValue={""}
                            />
                            <div className="help-block with-errors" />
                          </div>
                          {/* singel form */}
                        </div>
                        <p className="form-message" />
                        <div className="col-md-12">
                          <div className="singel-form">
                            <button
                              type="submit"
                              onClick={store}
                              className="main-btn"
                            >
                              Submit
                            </button>
                          </div>
                          {/* singel form */}
                        </div>
                      </div>
                      {/* row */}
                    </form>
                  </div>
                  {/* main form */}
                </div>
                {/* contact from */}
              </div>
              <div className="col-lg-5">
                <div className="contact-address mt-30">
                  <ul>
                    <li>
                      <div className="singel-address">
                        <div className="icon">
                          <i className="fa fa-home" />
                        </div>
                        <div className="cont">
                          <p>
                           Near Old ITI Rohtak (Haryana)
                          </p>
                        </div>
                      </div>
                      {/* singel address */}
                    </li>
                    <li>
                      <div className="singel-address">
                        <div className="icon">
                          <i className="fa fa-phone" />
                        </div>
                        <div className="cont">
                          <p>+91 0000000000</p>
                        </div>
                      </div>
                      {/* singel address */}
                    </li>
                    <li>
                      <div className="singel-address">
                        <div className="icon">
                          <i className="fa fa-envelope-o" />
                        </div>
                        <div className="cont">
                          <p>samridhisofficial@gmail.com</p>
                        </div>
                      </div>
                      {/* singel address */}
                    </li>
                  </ul>
                </div>
                {/* contact address */}
                <div className="map mt-30">
                  <div id="contact-map" />
                </div>
                {/* map */}
              </div>
            </div>
            {/* row */}
          </div>
          {/* container */}
        </section>
      </div>{" "}
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default Contact;
